import {
  PhoneInput,
  buildCountryData,
  defaultCountries,
  parseCountry,
} from 'react-international-phone';
import { oneLine } from 'common-tags';
import { ErrorMessage, Field } from 'formik';

import type { FieldProps } from 'formik';
import type { FunctionComponent } from 'react';
import type { TypeInternationalPhoneInputProps } from './types';
import 'react-international-phone/style.css';

const countriesList = defaultCountries.map((country) => {
  const parsedCountry = parseCountry(country);
  if (parsedCountry.iso2 === 'nl') {
    parsedCountry.format = '... ........';
  }
  return buildCountryData(parsedCountry);
});

export const InternationalPhoneInput: FunctionComponent<
  TypeInternationalPhoneInputProps
> = ({
  className = '',
  inputClassName = '',
  name,
  label,
  disabled = false,
  onChange,
  value,
}: TypeInternationalPhoneInputProps) => (
  <Field name={name} value={value} onChange={onChange}>
    {({ field, meta: { error, touched } }: FieldProps) => (
      <div
        className="flex flex-col aria-disabled:opacity-40"
        aria-disabled={disabled}
      >
        <div className="flex flex-col gap-2">
          {label && (
            <label
              htmlFor={name}
              className={oneLine`
                text-body text-body--s
                ${error && touched ? 'text-status-error' : ''}
              `}
            >
              {label}
            </label>
          )}
          <div className="relative flex">
            <PhoneInput
              {...field}
              name={name}
              value={value}
              defaultCountry="es"
              countries={countriesList}
              preferredCountries={['es', 'fr', 'it', 'de', 'gb']}
              forceDialCode={true}
              className={className}
              inputClassName={oneLine`
              text-body text-body--m w-full rounded py-3
              ${
                error && touched
                  ? 'error border-0 focus:border-0 focus:ring-0 active:border-0 active:ring-0'
                  : 'border-neutrals-500 placeholder:text-placeholder placeholder:text-text-neutrals-500 focus:border-neutrals-900 focus:ring-neutrals-900 active:border-neutrals-500 active:ring-neutrals-900'
              }
              ${inputClassName}
            `}
              onChange={onChange}
            />
          </div>
        </div>

        <ErrorMessage name={name}>
          {(msg: string) => (
            <div className="text-body text-body--s text-status-error">
              {msg}
            </div>
          )}
        </ErrorMessage>
      </div>
    )}
  </Field>
);

InternationalPhoneInput.displayName = 'InternationalPhoneInput';
